/* tslint:disable */

declare var Object: any;
export interface DigitaxActionsInterface {
  "id"?: number;
}

export class DigitaxActions implements DigitaxActionsInterface {
  "id": number;
  constructor(data?: DigitaxActionsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DigitaxActions`.
   */
  public static getModelName() {
    return "DigitaxActions";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DigitaxActions for dynamic purposes.
  **/
  public static factory(data: DigitaxActionsInterface): DigitaxActions{
    return new DigitaxActions(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DigitaxActions',
      plural: 'DigitaxActions',
      path: 'DigitaxActions',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
